import { Select, SelectContent, SelectTrigger, SelectValue, SelectGroup, SelectItem } from '@/components/ui/select'
import { useServiceType } from '@/stores/service-type'

export default function ServiceTypeSelector() {
  const { serviceType, setServiceType } = useServiceType()
  const serviceTypes = [
    { id: '1', label: 'Financial advice' },
    { id: '2', label: 'Mortgage advice' },
    { id: '3', label: 'Protection advice' },
    { id: '6', label: 'Equity release' },
  ]
  // this might change as it will come from the backend as default 1 if there's no default to set (ex.: 0 reviews)
  const defaultServiceType = serviceType ? serviceType.toString() : '1'

  const handleServiceTypeChange = (value: string) => {
    setServiceType(Number(value))
  }

  return (
    <div className="bg-white rounded-md p-1 box-border">
      <Select
        value={defaultServiceType}
        onValueChange={handleServiceTypeChange}
      >
        <SelectTrigger data-testid='select:service-type' className="w-full min-w-45 hover:bg-accent font-medium text-left text-[10px] leading-[10px] h-6 lg:text-xs gap-0 px-1 lg:px-2 py-0 lg:h-8 shadow-none border-0 focus:ring-0">
          <SelectValue placeholder={"Select service type"}/>
        </SelectTrigger>
        <SelectContent side="top">
          <SelectGroup>
            {serviceTypes.map(({ id, label }) => (
              <SelectItem
                key={`service-type-item:${id}`}
                value={id}
                className="data-[state=checked]:text-secondary data-[state=checked]:bg-transparent cursor-pointer"
                data-testid={`select-item-${id}`}
              >
                {label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  )
}